<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import sha_ from "./core/sha1";
export default {
    name: "App",
    mounted() {
		this.config_();
	},
	methods:{
		config_(){
			//获取token
			let url="/wechat-api/token/get";
			this.$axios.get(url).then(res => {
				let url_ = `/weixin/cgi-bin/ticket/getticket?access_token=${res.data.token}&type=jsapi`
				let appId = res.data.appid;
				this.$axios.get(url_).then(res_ => {
					let time_ = new Date().getTime()+""
					time_ = time_.slice(0,10)
					let mo_ = {
						noncestr:"Wm3WZYTPz0wzccnW1",
						jsapi_ticket:res_.data.ticket,
						timestamp:time_,
						url:"https://znxj.innno.net/"
					}
					
					let str_ = `jsapi_ticket=${mo_.jsapi_ticket}&noncestr=${mo_.noncestr}&timestamp=${mo_.timestamp}&url=${mo_.url}`
					mo_.signature = sha_.sha1(str_);
					wx.config({
						debug: false, //调试模式建议开启true
						appId: appId, //微信公众号的appid，不是个人的
						timestamp: mo_.timestamp,
						nonceStr: mo_.noncestr,   //生成签名的随机串
						signature: mo_.signature,  //签名
						jsApiList: ["hideMenuItems","openLocation","getLocation","authorize",] //下面要调用的微信接口写在这里，否则不能使用
					})
					wx.ready(function(){
						wx.authorize({
							scope: 'scope.userLocation',
						})
						wx.hideMenuItems({
							menuList: ['menuItem:share:appMessage',"menuItem:share:timeline"] 
						});
					})
					wx.error(function(res){
						// alert(res)
					})
				})
			})
		},
	}
};
</script>

<style>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;
    /* background-color: rgb(17, 50, 61); */

    user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue